import { createThemedUseStyles } from "theme";

export default createThemedUseStyles(theme => {
  return {
    root: {}
  };
});
